import { useMemo } from 'react'

import { createStyles } from 'antd-style'

import { searchArticleApi } from '@eastcoal/api/elasticsearch/articleMall/searchArticle'

import { PageContainer } from '@eastcoal/common/components/Layout/PageContainer'
import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { RouterLink } from '@eastcoal/router/components/Link'
import { SearchHighLightText } from '@eastcoal/shared/components/Search/HighLightText'
import { SearchResultCount } from '@eastcoal/shared/components/Search/ResultCount'
import { DocumentType } from '@eastcoal/shared/enums/DocumentType'

import { HOME_PAGE_PATH } from '../Home/constants/path'

import { SearchTableProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  title: {
    fontSize: token.fontSizeLG,
    [`&:hover em`]: {
      color: token.colorLinkHover
    },
    [`&:active em`]: {
      color: token.colorLinkActive
    }
  },
  content: {
    display: 'block',
    marginBlockStart: token.marginXXS,
    color: token.colorTextSecondary,
    wordBreak: 'break-all',
    whiteSpace: 'normal'
  },
  time: {
    fontSize: token.fontSizeLG,
    color: token.colorTextSecondary,
    verticalAlign: 'top'
  }
}))

export const SearchPage = () => {
  const { keyword } = useUrlParams()

  const { styles } = useStyles()

  const columns: SearchTableProps['columns'] = useMemo(
    () => [
      {
        dataIndex: 'title',
        render(_, { id, title, content }) {
          const to = stringifyUrl({
            url: HOME_PAGE_PATH,
            query: { id }
          })

          return (
            <>
              <RouterLink newtab className={styles.title} to={to} type='text'>
                <SearchHighLightText text={title} />
              </RouterLink>
              <SearchHighLightText className={styles.content} text={content} />
            </>
          )
        }
      },
      {
        dataIndex: 'publishTime',
        width: 150,
        className: styles.time
      }
    ],
    [styles]
  )

  return (
    <PageContainer breadcrumb={false}>
      <RemoteTable
        api={searchArticleApi}
        bordered={false}
        columns={columns}
        readyRequest={!!keyword}
        refreshDeps={[keyword]}
        rowKey='id'
        showHeader={false}
        requestParams={{
          search: keyword,
          documentTypes: [DocumentType.SUPPORT]
        }}
        title={
          keyword ? () => <SearchResultCount search={keyword} /> : undefined
        }
      />
    </PageContainer>
  )
}
